// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0abc4f4","453":"809171bb","667":"e9509e75","821":"e13f8b29","977":"1af3584f"}[chunkId] + ".chunk.js";
};